/**
 * Created by 叶子 on 2017/7/30.
 */
export const REQUEST_DATA = 'REQUEST_DATA';

export const RECEIVE_DATA = 'RECEIVE_DATA';

export const COUNT_All = 'COUNT_All';

export const COUNT_All_MY = 'COUNT_All_MY';

export const COUNT_NUMBER_MY = 'COUNT_NUMBER_MY';

export const ORDER_NO = 'ORDER_NO';

export const VISIBLE_DATA = 'VISIBLE_DATA';

export const COUNT_NUMBER = 'COUNT_NUMBER';

export const FLAG = 'FLAG';



// WEBPACK FOOTER //
// ./src/action/type.js